const routes = [
  {
    path: "/telemetry",
    name: "telemetry",
    component: () => import(/* webpackChunkName: "telemetry" */ "../views/telemetry/index.vue"),
    meta: { section_name: "telemetry" },
  },
  {
    path: "/telemetry/map",
    name: "telemetry-map",
    component: () => import(/* webpackChunkName: "telemetry-map" */ "../views/telemetry/map.vue"),
    meta: { section_name: "telemetry" },
  },
  {
    path: "/telemetry/trips",
    name: "telemetry-trips",
    component: () => import(/* webpackChunkName: "telemetry-trips" */ "../views/telemetry/trips.vue"),
    meta: { section_name: "telemetry" },
  },
  {
    path: "/telemetry/vehicles",
    name: "telemetry-vehicles",
    component: () => import(/* webpackChunkName: "telemetry-vehicles" */ "../views/telemetry/vehicles.vue"),
    meta: { section_name: "telemetry" },
  },
  {
    path: "/telemetry/vehicle/:vehicleId/map",
    name: "telemetry-vehicle-map",
    component: () => import(/* webpackChunkName: "telemetry-vehicle-map" */ "../views/telemetry/vehicle-map.vue"),
    meta: { section_name: "telemetry" },
    props: (route) => {
      return {
        ...route.params,
        ...{
          vehicleId: route.params.vehicleId,
        },
      };
    },
  },
  {
    path: "/telemetry/vehicles-map",
    name: "telemetry-vehicles-map",
    component: () => import(/* webpackChunkName: "telemetry-vehicles-map" */ "../views/telemetry/vehicles-map.vue"),
    meta: { section_name: "telemetry" },
  },

  {
    path: "/telemetry/routes",
    name: "telemetry-routes",
    component: () => import(/* webpackChunkName: "telemetry-routes" */ "../views/telemetry/routes.vue"),
    meta: { section_name: "telemetry" },
  },
  {
    path: "/telemetry/routes/create",
    name: "telemetry-routes-create",
    component: () => import(/* webpackChunkName: "telemetry-routes-create" */ "../views/telemetry/routes-create.vue"),
    meta: { section_name: "telemetry" },
  },
];
export default routes;
